import { Button, Box, useTheme } from "@mui/material";
import React from "react";

export default function GradientButton({ children, fullWidth, onClick, sx, disabled, addStyle }) {
  const theme = useTheme();

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      sx={{
        ...sx,
        background:
          "linear-gradient(90deg, rgba(204,48,69,1) 0%, rgba(234,96,165,1) 20%, rgba(245,225,124,1) 40%, rgba(79,173,91,1) 60%, rgba(50,152,196,1) 80%, rgba(175,145,189,1) 100%)",
        borderRadius: "24px",
        width: fullWidth ? "100%" : "auto",
        opacity: disabled ? 0.5 : 1,
        [theme.breakpoints.up("laptop")]: {
          padding: "4px",
        },
        [theme.breakpoints.down("laptop")]: {
          padding: "3px",
          fontSize: "13px",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "background.inverted",
          color: "text.inverted",
          width: fullWidth ? "100%" : "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          [theme.breakpoints.up("laptop")]: {
            padding: "4px 48px",
          },
          [theme.breakpoints.up("laptop")]: {
            padding: "4px 32px",
            borderRadius: "18px",
          },
          [theme.breakpoints.up("mobile")]: {
            padding: "3px 20px",
            borderRadius: "22px",
          },
          ...addStyle,
        }}
      >
        {children}
      </Box>
    </Button>
  );
}
